import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProductBundle = styled.ul`
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #777;
  line-height: 1.4;
  list-style: none;
`;

const Icon = styled.i`
  min-width: 21px;
  margin: -3px 0 0 -2px;
  font-size: 21px;
`;

const Item = styled.li`
  overflow: hidden;
  width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const GridItemOutfitsInfo = ({ comboKitItemsNames }) => (
  <ProductBundle className={'productBundle'}>
    {comboKitItemsNames &&
      comboKitItemsNames.map((comboKitItemName, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Item key={i} className={'nowrap wide'}>
          <Icon className={'dcg-icon-plus'} />
          {comboKitItemName}
        </Item>
      ))}
  </ProductBundle>
);

GridItemOutfitsInfo.propTypes = {
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string)
};

GridItemOutfitsInfo.defaultProps = {
  comboKitItemsNames: undefined
};

export default GridItemOutfitsInfo;
